export const roundPrecision = (number, precision = 2) => {
  let roundedNumber = number;
  roundedNumber *= 10 ** precision;
  roundedNumber = Math.round(roundedNumber);
  roundedNumber /= 10 ** precision;
  return roundedNumber;
};
